<template>
    <div class="legal-cases">
        <b-card no-body class="p-3">
            <b-row align-v="center">
                <b-col cols="6">
                    <h3 class="mb-0">
                        Legal Cases
                    </h3>
                </b-col>
                <b-col cols="6">
                    <span v-if="legal_issue.length > 0" class="float-right font-weight-600 text-danger">{{ legal_issue.length }} Issue{{ legal_issue.length > 1 ? 's' : '' }}</span>
                    <span v-else class="float-right text-muted">No Issue</span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import { Card, Button } from 'element-ui'
import { mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'

export default {
    name: 'legal-cases',
    components: {
        [Card.name]: Card,
        [Button.name]: Button,
    },
    data() {
        return {
            legal_issue: '',
        }
    },
    computed:{
        ...mapState(useCustomerStore, ['current_commitment'])
    },
    watch: {
        current_commitment: {
            handler(newVal){
                if(newVal){
                    this.legal_issue = newVal.credit_report_summary.legal_cases
                }
            }
        }
    }
}
</script>